import React, { useState, useEffect, useRef } from 'react';
import logo from "../assets/main/catgram.png";
import home from "../assets/main/home.png";
import profile from "../assets/main/profile.jpg";
import like from "../assets/main/like.gif";
import download from "../assets/main/download.gif";
import images from '../assets/loadimages';

const storyImages = [
  like,
  download
];

const getRandomImage = () => {
  return images[Math.floor(Math.random() * images.length)];
};

const generateRandomUsername = () => {
  const characters = ['meow', 'meok', 'mew', 'moow', 'meeeoww', 'me', 'ooo', 'ww', '~', '!', '^', '>', '<', '*', '_', '!!!'];
  let username = '';
  while (username.length < 7) {
    username += characters[Math.floor(Math.random() * characters.length)];
  }
  return username.slice(0, 7);
};

const generateRandomCaptions = () => {
  const words = ["🐾", "😺", "😹", "😽", "😻", "meow", "meeeeooww", "eeemeoww", "😻", "💩", "😾", "❤️", "🐈","🐈‍⬛","🐆","🐅","🐯","🦁","🐾🐾","👅","🧊","🌲","🌲🌲", "😸", "😸", "meok!", "meowmeowmeow"];
  let caption = '';
  while (caption.length < 15) {
    caption += words[Math.floor(Math.random() * words.length)];
  }
  return caption.slice(0, 15);
};

const HomePage = () => {
  const [posts, setPosts] = useState(Array.from({ length: 10 }, () => ({
    image: getRandomImage(),
    username: generateRandomUsername(),
    caption: generateRandomCaptions(),
    isHearted: false,
    id: Math.random() // Unique ID for each post
  })));
  const [loadingMore, setLoadingMore] = useState(false);
  const [viewingStory, setViewingStory] = useState(false);
  const [currentStoryIndex, setCurrentStoryIndex] = useState(0);
  const storyTimerRef = useRef(null);

  useEffect(() => {
    if (viewingStory) {
      // Set a timer to automatically close the story after 3 seconds
      storyTimerRef.current = setTimeout(() => {
        closeStory();
      }, 5000);

      // Clear the timer if the user interacts with the story viewer
      return () => clearTimeout(storyTimerRef.current);
    }
  }, [viewingStory]);

  const toggleHeart = (index) => {
    setPosts(prevPosts =>
      prevPosts.map((post, i) =>
        i === index ? { ...post, isHearted: !post.isHearted } : post
      )
    );
  };

  const loadMorePosts = () => {
    setLoadingMore(true);
    setTimeout(() => {
      setPosts(prevPosts => [
        ...prevPosts,
        ...Array.from({ length: 10 }, () => ({
          image: getRandomImage(),
          username: generateRandomUsername(),
          caption: generateRandomCaptions(),
          isHearted: false,
          id: Math.random() // Unique ID for each post
        }))
      ]);
      setLoadingMore(false);
    }, 1000); // Simulate a loading delay
  };

  const downloadImage = (imageUrl) => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = 'image.jpg'; // Default filename
    link.click();
  };

  const openStory = (index) => {
    setCurrentStoryIndex(index);
    setViewingStory(true);
  };

  const closeStory = () => {
    setViewingStory(false);
    clearTimeout(storyTimerRef.current); // Clear the timer when closing
  };

  const nextStory = () => {
    setCurrentStoryIndex((prevIndex) => (prevIndex + 1) % storyImages.length);
  };

  const prevStory = () => {
    setCurrentStoryIndex((prevIndex) => (prevIndex - 1 + storyImages.length) % storyImages.length);
  };

  return (
    <div className="bg-white min-h-screen flex flex-col items-center" id="top">
      {/* Header */}
      <header className="w-full bg-white p-4 border-b border-black-200 fixed top-0 z-10">
        <div className="max-w-4xl mx-auto flex justify-between items-center">
          <h1 className="text-2xl font-bold"><img src={logo} alt="catgram" width={100} height={50} /></h1>
          <div className="flex space-x-4">
            <div className="cursor-pointer p-1 hover:bg-gradient-to-b from-pink-600 to-white"><a href="#top"><img src={home} alt="Home" width={20} height={20} className="mt-1" /></a></div>
            <div className="cursor-pointer p-1 hover:bg-gradient-to-b from-pink-600 to-white"><a href="https://pranay-p0rtf0li0.vercel.app/"><img src={profile} alt="Portfolio" width={30} height={30} /></a></div>
          </div>
        </div>
      </header>
      {/* Stories */}
      <section className="w-full bg-white p-4 border-b border-gray-300 mt-16">
        <div className="max-w-4xl mx-auto flex space-x-4 overflow-x-scroll">
          {storyImages.map((image, index) => (
            <div key={index} className="h-12 w-12 bg-gradient-to-r from-yellow-500 to-pink-300 rounded-full cursor-pointer" onClick={() => openStory(index)}>
              <img src={image} className="w-[90%] h-[90%] mx-0.5 my-0.5 rounded-full overflow-hidden flex justify-center items-center" />
            </div>
          ))}
        </div>
      </section>
      {/* Posts */}
      <main className="w-[400px] md:w-[300px] lg:w-[400px] max-w-4xl mx-auto mt-4">
        {posts.map((post, index) => (
          <div key={post.id} className="bg-white border border-black-200 mb-4 rounded-lg overflow-hidden shadow-sm">
            <div className="p-4 flex justify-between items-center">
              <div className="flex items-center">
                <div className="h-10 w-10 bg-black-200 rounded-full">
                  <img src={post.image} alt={`Post ${index + 1}`} className="rounded-full h-[30px] w-[30px] mt-1 " />
                </div>
                <div className="ml-4">{post.username}</div>
              </div>
              <div className="cursor-pointer">...</div>
            </div>
            <img src={post.image} alt={`Post ${index + 1}`} className="w-[400px] md:w-[300px] lg:w-[400px] h-[400px] md:h-[300px] lg:h-[400px] object-cover" />
            <div className="p-4">
              <div className="flex justify-between items-center">
                <div className="flex space-x-4">
                  <div onClick={() => toggleHeart(index)} className="cursor-pointer">
                    {post.isHearted ? '❤️' : '♡'}
                  </div>
                  <div className="cursor-pointer">💬</div>
                  <div onClick={() => downloadImage(post.image)} className="cursor-pointer">📤</div>
                </div>
                <div className="cursor-pointer">🔖</div>
              </div>
              <div className="mt-2">Liked by User and others</div>
              <div className="mt-2"><b>{post.username}</b>: {post.caption}</div>
            </div>
          </div>
        ))}
        <div className="flex justify-center mt-4">
          <button onClick={loadMorePosts} className="bg-blue-500 text-white px-4 py-2 rounded" disabled={loadingMore}>
            {loadingMore ? 'Loading...' : 'Load More'}
          </button>
        </div>
      </main>
      {/* Story Viewer */}
      {viewingStory && (
        <div className="story-viewer fixed top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center">
          <img src={storyImages[currentStoryIndex]} alt={`Story ${currentStoryIndex + 1}`} className="max-w-full max-h-full" />
          <div className="absolute top-1/2 left-0 w-full flex justify-between px-4">
            <button onClick={prevStory} className="text-white text-2xl">◀️</button>
            <button onClick={nextStory} className="text-white text-2xl">▶️</button>
          </div>
          <button onClick={closeStory} className="absolute top-4 right-4 text-white text-2xl">✖️</button>
        </div>
      )}
      <footer className="flex items-center text-1xl mt-3">
        <a href="https://pranay-p0rtf0li0.vercel.app/">&copy; 2024 . Pranay Jain</a>
      </footer>
    </div>
  );
};

export default HomePage;
